export default "__VITE_ASSET__45c82ad9__"